// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Sd from "common/src/tft-static/Sd.bs.js";
import * as Data from "common/src/data/Data.bs.js";
import * as Dict from "common/src/util/Dict.bs.js";
import * as Link from "../Link.bs.js";
import * as React from "react";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as AdLayout from "../app-core/AdLayout.bs.js";
import * as UnitImage from "common/src/tft-static/UnitImage.bs.js";
import * as UnitName0 from "common/src/tft-static/UnitName0.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as TraitImage from "common/src/tft-static/TraitImage.bs.js";
import * as TraitName0 from "common/src/tft-static/TraitName0.bs.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as ContentSection from "common/src/ContentSection.bs.js";
import * as RitoDescription2 from "common/src/components/RitoDescription2.bs.js";

function TraitInfoPage$UnitInfo(Props) {
  var unitId = Props.unitId;
  var traitId = Props.traitId;
  var set = TftSet.use(undefined);
  var t = Translation.useT(/* Units */1);
  var abilityName = t(unitId + "_ability");
  var desc = t(unitId + "_desc");
  var traits = Belt_Array.keep(Sd.getUnitTraits(unitId, set), (function (t) {
          return t !== traitId;
        }));
  return React.createElement(Link.make, {
              route: {
                TAG: /* Info */6,
                _0: {
                  TAG: /* Unit */0,
                  _0: set,
                  _1: unitId
                }
              },
              children: React.createElement("div", undefined, React.createElement("div", {
                        className: "flex items-center gap-2"
                      }, React.createElement("h3", {
                            className: "block text-[20px] pr-2 font-montserrat font-medium"
                          }, React.createElement(UnitName0.make, {
                                unit: unitId
                              })), Belt_Array.map(traits, (function (traitId) {
                              return React.createElement("div", {
                                          className: "flex items-center px-2 py-1 bg-bg3 rounded-full gap-[2px] items-center"
                                        }, React.createElement(TraitImage.PlainIcon.make, {
                                              traitId: traitId,
                                              size: 20
                                            }), React.createElement("div", {
                                              className: "pt-[2px]"
                                            }, React.createElement(TraitName0.make, {
                                                  trait: traitId
                                                })));
                            }))), React.createElement("div", {
                        className: "flex gap-3 pt-1"
                      }, React.createElement("div", {
                            className: "flex-shrink-0 pt-[5px]"
                          }, React.createElement(UnitImage.make, {
                                unitId: unitId,
                                size: 40
                              })), React.createElement("div", {
                            className: "leading-tight"
                          }, React.createElement("h4", {
                                className: "font-montserrat font-medium"
                              }, abilityName), React.createElement(RitoDescription2.make, {
                                desc: desc
                              }))))
            });
}

var UnitInfo = {
  make: TraitInfoPage$UnitInfo
};

function TraitInfoPage$Inner(Props) {
  var traitId = Props.traitId;
  var set = TftSet.use(undefined);
  var t = Translation.useT(/* Traits */2);
  var commonT = Translation.useT(/* Common */0);
  Dict.getExn(Data.traits(set), traitId);
  var desc = t(traitId + "_desc");
  var units = Sd.getTraitUnits(traitId, set);
  return React.createElement(AdLayout.make, {
              children: React.createElement("div", {
                    className: "mx-auto flex flex-col items-center sm:w-[700px]"
                  }, React.createElement(ContentSection.make, {
                        children: null
                      }, React.createElement("div", {
                            className: "flex items-center gap-2 pb-2"
                          }, React.createElement("div", {
                                className: "flex flex-col items-center gap-1 flex-shrink-0"
                              }, React.createElement(TraitImage.PlainIcon.make, {
                                    traitId: traitId,
                                    size: 36
                                  })), React.createElement("h1", {
                                className: "block text-2xl font-montserrat font-medium"
                              }, React.createElement(TraitName0.make, {
                                    trait: traitId
                                  }))), React.createElement("div", {
                            className: "flex gap-4"
                          }, React.createElement("div", {
                                className: "leading-tight"
                              }, React.createElement(RitoDescription2.make, {
                                    desc: desc
                                  })))), React.createElement(ContentSection.make, {
                        className: "mt-4",
                        children: null
                      }, React.createElement("h2", {
                            className: "text-2xl font-montserrat font-medium mb-3"
                          }, commonT("Units")), React.createElement("div", {
                            className: "flex flex-col gap-6"
                          }, Belt_Array.map(units, (function (unitId) {
                                  return React.createElement(TraitInfoPage$UnitInfo, {
                                              unitId: unitId,
                                              traitId: traitId
                                            });
                                })))))
            });
}

var Inner = {
  make: TraitInfoPage$Inner
};

function TraitInfoPage(Props) {
  var traitId = Props.traitId;
  var set = Props.set;
  return React.createElement(TftSet.Provider.make, TftSet.Provider.makeProps(TftSet.fromNum(set), React.createElement(TraitInfoPage$Inner, {
                      traitId: traitId
                    }), undefined));
}

var make = TraitInfoPage;

export {
  UnitInfo ,
  Inner ,
  make ,
  
}
/* Sd Not a pure module */
